import { useState } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { User } from '@magnetar/admin-api-interfaces'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Settings } from 'lucide-react'
import { UserSettingDialog } from './UserSettingDialog'
import { DeleteAlert } from './DeleteAlert'

type TableMeta = {
  reloadData: () => void
}

export const columns: ColumnDef<User, unknown>[] = [
  {
    accessorKey: 'user_id',
    header: 'ID',
    cell: ({ row }) => (
      <Badge variant="outline" className="font-medium">
        {row.getValue('user_id')}
      </Badge>
    ),
  },
  {
    accessorKey: 'account',
    header: '帳號',
  },
  {
    accessorKey: 'email',
    header: 'Email',
  },
  {
    accessorKey: 'phone',
    header: '手機',
  },
  {
    accessorKey: 'user_name',
    header: '使用者名稱',
  },
  {
    accessorKey: 'user_role.role_name',
    header: '角色',
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => (
      <Badge variant={row.getValue('is_active') ? 'default' : 'secondary'}>
        {row.getValue('is_active') ? '啟用' : '停用'}
      </Badge>
    ),
  },
  {
    id: 'actions',
    cell: function ActionsCell({ row, table }) {
      const user = row.original
      const [showEditDialog, setShowEditDialog] = useState(false)
      const [showDeleteAlert, setShowDeleteAlert] = useState(false)
      const meta = table.options.meta as TableMeta

      return (
        <>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="h-8 w-8 p-0">
                <span className="sr-only">Open menu</span>
                <Settings className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel>操作</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onSelect={() => setShowEditDialog(true)}>編輯</DropdownMenuItem>
              <DropdownMenuItem
                className="text-destructive"
                onSelect={() => setShowDeleteAlert(true)}
              >
                刪除
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <UserSettingDialog
            user={user}
            open={showEditDialog}
            onOpenChange={setShowEditDialog}
            onSuccess={() => meta.reloadData()}
          />

          <DeleteAlert
            open={showDeleteAlert}
            onOpenChange={setShowDeleteAlert}
            userId={user.user_id}
            onConfirm={() => meta.reloadData()}
          />
        </>
      )
    },
  },
]
